import {deferredValue} from '../../util';
import {Component} from './component';

export class Components<T extends Component> {
  private readonly componentsValue: () => Map<string, T>;

  constructor(selector: string, componentFactory: (el: HTMLElement) => T) {
    this.componentsValue = deferredValue(() => {
      const $components = Array.from(document.querySelectorAll(selector)) as HTMLElement[];
      return new Map($components.map($component => {
        const instance = componentFactory($component);
        return [instance.name, instance] as [string, T];
      }));
    });
  }

  get(name: string) {
    return this.componentsValue().get(name);
  }

  setHelptext(values = new Map<string, string>()) {
    this.componentsValue().forEach(component => {
      component.helptext = values.get(component.name) || '';
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/components/components.ts